export default {
    bugsnag: {
        suppressLogs: true,
    },
};
